/* eslint-disable import/first,no-func-assign */
import Dlp from './Dlp';
import AccountAnalyticsLogo from './AccountAnalyticsLogo';
import AddMember from './AddMember';
import Add from './Add';
import AiAudit from './AiAudit';
import AnalyticsData from './AnalyticsData';
import AnalyticsSearch from './AnalyticsSearch';
import ApiSecurity from './ApiSecurity';
import Api from './Api';
import Applications from './Applications';
import ArrowDown from './ArrowDown';
import ArrowExternalLink from './ArrowExternalLink';
import Backward from './Backward';
import Bolt from './Bolt';
import BookmarkOutline from './BookmarkOutline';
import Byoip from './Byoip';
import Calendar from './Calendar';
import Calls from './Calls';
import CaptchaOutline from './CaptchaOutline';
import Carbon from './Carbon';
import CaretDoubleLeft from './CaretDoubleLeft';
import CaretDoubleRight from './CaretDoubleRight';
import CaretDownStroke from './CaretDownStroke';
import CaretDown from './CaretDown';
import CaretLeftStroke from './CaretLeftStroke';
import CaretLeft from './CaretLeft';
import CaretReorder2 from './CaretReorder2';
import CaretRightStroke from './CaretRightStroke';
import CaretRight from './CaretRight';
import CaretUpStroke from './CaretUpStroke';
import CaretUp from './CaretUp';
import CaseStudy from './CaseStudy';
import Certificate from './Certificate';
import Chart from './Chart';
import Clipboard from './Clipboard';
import CloudInternetSolid from './CloudInternetSolid';
import CloudInternet from './CloudInternet';
import CloudMulti from './CloudMulti';
import CloudSecurity from './CloudSecurity';
import CloudflareAccess from './CloudflareAccess';
import CloudflareBrowserOutline from './CloudflareBrowserOutline';
import CloudflareDex from './CloudflareDex';
import CloudflareEmailSecurity from './CloudflareEmailSecurity';
import CloudflareMagicWan from './CloudflareMagicWan';
import CloudflarePipelines from './CloudflarePipelines';
import CloudflareRulesetEngine from './CloudflareRulesetEngine';
import CloudflareSecurityApplication from './CloudflareSecurityApplication';
import CloudflareSecurityNetwork from './CloudflareSecurityNetwork';
import CloudflareZeroTrust from './CloudflareZeroTrust';
import CodeApiOutline from './CodeApiOutline';
import CodeEdit from './CodeEdit';
import Code from './Code';
import Connector from './Connector';
import Copy from './Copy';
import CornerDownRight from './CornerDownRight';
import CreditCard from './CreditCard';
import D1 from './D1';
import DdosAttackOutline from './DdosAttackOutline';
import DdosAttack from './DdosAttack';
import DeviceDesktop from './DeviceDesktop';
import DeviceLaptop from './DeviceLaptop';
import DeviceMobile from './DeviceMobile';
import DeviceTablet from './DeviceTablet';
import Discord from './Discord';
import Discover from './Discover';
import Documentation from './Documentation';
import Download from './Download';
import DragOutline from './DragOutline';
import DragSolid from './DragSolid';
import Drive from './Drive';
import EdgeLogDelivery from './EdgeLogDelivery';
import Edgeworker from './Edgeworker';
import Edit from './Edit';
import EmailForwarding from './EmailForwarding';
import ExclamationSign from './ExclamationSign';
import Expand from './Expand';
import ExternalLink from './ExternalLink';
import Eye from './Eye';
import Facebook from './Facebook';
import File from './File';
import FilterDrawerOutline from './FilterDrawerOutline';
import Filter from './Filter';
import FirewallRules from './FirewallRules';
import Flowchart from './Flowchart';
import Folder from './Folder';
import Forward from './Forward';
import Funnel from './Funnel';
import GarbageOutline from './GarbageOutline';
import Garbage from './Garbage';
import Gateway from './Gateway';
import Gear from './Gear';
import GitBranch from './GitBranch';
import Github from './Github';
import Globe from './Globe';
import Hamburger from './Hamburger';
import Help from './Help';
import HideEye from './HideEye';
import Home from './Home';
import Hyperdrive from './Hyperdrive';
import Image from './Image';
import Inbox from './Inbox';
import InfoSign from './InfoSign';
import InternetBrowser from './InternetBrowser';
import Key from './Key';
import Leaf from './Leaf';
import Left from './Left';
import Link from './Link';
import Linkedin from './Linkedin';
import List from './List';
import Lock from './Lock';
import Logs from './Logs';
import MachineLearningContextualOutline from './MachineLearningContextualOutline';
import MagicFirewall from './MagicFirewall';
import MagicNetworkMonitoring from './MagicNetworkMonitoring';
import MagicTransitLogo from './MagicTransitLogo';
import Mail from './Mail';
import MediaPlay from './MediaPlay';
import Minus from './Minus';
import More from './More';
import NetworkAnalyticsLogo from './NetworkAnalyticsLogo';
import NetworkSecurity from './NetworkSecurity';
import Network from './Network';
import NoEdit from './NoEdit';
import None from './None';
import Notifications from './Notifications';
import OfficeBranch from './OfficeBranch';
import OkSign from './OkSign';
import Ok from './Ok';
import OptimizationScale from './OptimizationScale';
import PagesLogo from './PagesLogo';
import Pause from './Pause';
import PerformanceArrowUp from './PerformanceArrowUp';
import PinOutline from './PinOutline';
import PinSolid from './PinSolid';
import PlatformApps from './PlatformApps';
import Plus from './Plus';
import PodcastMicrophoneOutline from './PodcastMicrophoneOutline';
import PodcastMicrophoneSolid from './PodcastMicrophoneSolid';
import PreemptiveOutline from './PreemptiveOutline';
import Printer from './Printer';
import Processing from './Processing';
import ProductSecurityCenter from './ProductSecurityCenter';
import PubSub from './PubSub';
import PullRequest from './PullRequest';
import Queues from './Queues';
import R2Outline from './R2Outline';
import R2 from './R2';
import Refresh from './Refresh';
import RegistrarLogo from './RegistrarLogo';
import ReliabilityDns from './ReliabilityDns';
import ReliabilityLoadBalancer from './ReliabilityLoadBalancer';
import Remove from './Remove';
import Reorder from './Reorder';
import ResizeHorizontal from './ResizeHorizontal';
import Retarget from './Retarget';
import Revert from './Revert';
import Right from './Right';
import Router from './Router';
import Script from './Script';
import Search from './Search';
import SecurityBots from './SecurityBots';
import SecurityWafSolid from './SecurityWafSolid';
import SecurityWaf from './SecurityWaf';
import ServerOrigin from './ServerOrigin';
import ShareArrowOutline from './ShareArrowOutline';
import Shield from './Shield';
import Spectrum from './Spectrum';
import Speech from './Speech';
import StarOutline from './StarOutline';
import Star from './Star';
import Stream from './Stream';
import Subtract from './Subtract';
import Table from './Table';
import TailWorker from './TailWorker';
import Target from './Target';
import Teams from './Teams';
import Terraform from './Terraform';
import ThumbsDownOutline from './ThumbsDownOutline';
import ThumbsDownSolid from './ThumbsDownSolid';
import ThumbsUpOutline from './ThumbsUpOutline';
import ThumbsUpSolid from './ThumbsUpSolid';
import Time from './Time';
import Timer from './Timer';
import Trace from './Trace';
import TrafficAttackBrowser from './TrafficAttackBrowser';
import Turnstile from './Turnstile';
import Twitter from './Twitter';
import TwoWay from './TwoWay';
import UnlockOutline from './UnlockOutline';
import Upload from './Upload';
import UserMulti from './UserMulti';
import UserOutline from './UserOutline';
import User from './User';
import Vectorize from './Vectorize';
import Version from './Version';
import WaitingRoom from './WaitingRoom';
import Warning from './Warning';
import Warp from './Warp';
import WebAnalyticsLogo from './WebAnalyticsLogo';
import Web3 from './Web3';
import WorkersBundled from './WorkersBundled';
import WorkersConstellation from './WorkersConstellation';
import WorkersDurableObjects from './WorkersDurableObjects';
import WorkersForPlatforms from './WorkersForPlatforms';
import WorkersKv from './WorkersKv';
import WorkersPages from './WorkersPages';
import WorkersUnbound from './WorkersUnbound';
import Wrangler from './Wrangler';
import Wrench from './Wrench';
import Youtube from './Youtube';
import Zaraz from './Zaraz';
import ZeroTrustRiskScoring from './ZeroTrustRiskScoring';
import ZerotrustCasbLogo from './ZerotrustCasbLogo';
import ZerotrustNetworksLogo from './ZerotrustNetworksLogo';
const IconComponents = {
  dlp: Dlp,
  'account-analytics-logo': AccountAnalyticsLogo,
  'add-member': AddMember,
  add: Add,
  'ai-audit': AiAudit,
  'analytics-data': AnalyticsData,
  'analytics-search': AnalyticsSearch,
  'api-security': ApiSecurity,
  api: Api,
  applications: Applications,
  'arrow-down': ArrowDown,
  'arrow-external-link': ArrowExternalLink,
  backward: Backward,
  bolt: Bolt,
  'bookmark-outline': BookmarkOutline,
  byoip: Byoip,
  calendar: Calendar,
  calls: Calls,
  'captcha-outline': CaptchaOutline,
  carbon: Carbon,
  'caret-double-left': CaretDoubleLeft,
  'caret-double-right': CaretDoubleRight,
  'caret-down-stroke': CaretDownStroke,
  'caret-down': CaretDown,
  'caret-left-stroke': CaretLeftStroke,
  'caret-left': CaretLeft,
  'caret-reorder2': CaretReorder2,
  'caret-right-stroke': CaretRightStroke,
  'caret-right': CaretRight,
  'caret-up-stroke': CaretUpStroke,
  'caret-up': CaretUp,
  'case-study': CaseStudy,
  certificate: Certificate,
  chart: Chart,
  clipboard: Clipboard,
  'cloud-internet-solid': CloudInternetSolid,
  'cloud-internet': CloudInternet,
  'cloud-multi': CloudMulti,
  'cloud-security': CloudSecurity,
  'cloudflare-access': CloudflareAccess,
  'cloudflare-browser-outline': CloudflareBrowserOutline,
  'cloudflare-dex': CloudflareDex,
  'cloudflare-email-security': CloudflareEmailSecurity,
  'cloudflare-magic-wan': CloudflareMagicWan,
  'cloudflare-pipelines': CloudflarePipelines,
  'cloudflare-ruleset-engine': CloudflareRulesetEngine,
  'cloudflare-security-application': CloudflareSecurityApplication,
  'cloudflare-security-network': CloudflareSecurityNetwork,
  'cloudflare-zero-trust': CloudflareZeroTrust,
  'code-api-outline': CodeApiOutline,
  'code-edit': CodeEdit,
  code: Code,
  connector: Connector,
  copy: Copy,
  'corner-down-right': CornerDownRight,
  'credit-card': CreditCard,
  d1: D1,
  'ddos-attack-outline': DdosAttackOutline,
  'ddos-attack': DdosAttack,
  'device-desktop': DeviceDesktop,
  'device-laptop': DeviceLaptop,
  'device-mobile': DeviceMobile,
  'device-tablet': DeviceTablet,
  discord: Discord,
  discover: Discover,
  documentation: Documentation,
  download: Download,
  'drag-outline': DragOutline,
  'drag-solid': DragSolid,
  drive: Drive,
  'edge-log-delivery': EdgeLogDelivery,
  edgeworker: Edgeworker,
  edit: Edit,
  'email-forwarding': EmailForwarding,
  'exclamation-sign': ExclamationSign,
  expand: Expand,
  'external-link': ExternalLink,
  eye: Eye,
  facebook: Facebook,
  file: File,
  'filter-drawer-outline': FilterDrawerOutline,
  filter: Filter,
  'firewall-rules': FirewallRules,
  flowchart: Flowchart,
  folder: Folder,
  forward: Forward,
  funnel: Funnel,
  'garbage-outline': GarbageOutline,
  garbage: Garbage,
  gateway: Gateway,
  gear: Gear,
  'git-branch': GitBranch,
  github: Github,
  globe: Globe,
  hamburger: Hamburger,
  help: Help,
  'hide-eye': HideEye,
  home: Home,
  hyperdrive: Hyperdrive,
  image: Image,
  inbox: Inbox,
  'info-sign': InfoSign,
  'internet-browser': InternetBrowser,
  key: Key,
  leaf: Leaf,
  left: Left,
  link: Link,
  linkedin: Linkedin,
  list: List,
  lock: Lock,
  logs: Logs,
  'machine-learning-contextual-outline': MachineLearningContextualOutline,
  'magic-firewall': MagicFirewall,
  'magic-network-monitoring': MagicNetworkMonitoring,
  'magic-transit-logo': MagicTransitLogo,
  mail: Mail,
  'media-play': MediaPlay,
  minus: Minus,
  more: More,
  'network-analytics-logo': NetworkAnalyticsLogo,
  'network-security': NetworkSecurity,
  network: Network,
  'no-edit': NoEdit,
  none: None,
  notifications: Notifications,
  'office-branch': OfficeBranch,
  'ok-sign': OkSign,
  ok: Ok,
  'optimization-scale': OptimizationScale,
  'pages-logo': PagesLogo,
  pause: Pause,
  'performance-arrow-up': PerformanceArrowUp,
  'pin-outline': PinOutline,
  'pin-solid': PinSolid,
  'platform-apps': PlatformApps,
  plus: Plus,
  'podcast-microphone-outline': PodcastMicrophoneOutline,
  'podcast-microphone-solid': PodcastMicrophoneSolid,
  'preemptive-outline': PreemptiveOutline,
  printer: Printer,
  processing: Processing,
  'product-security-center': ProductSecurityCenter,
  'pub-sub': PubSub,
  'pull-request': PullRequest,
  queues: Queues,
  r2outline: R2Outline,
  r2: R2,
  refresh: Refresh,
  'registrar-logo': RegistrarLogo,
  'reliability-dns': ReliabilityDns,
  'reliability-load-balancer': ReliabilityLoadBalancer,
  remove: Remove,
  reorder: Reorder,
  'resize-horizontal': ResizeHorizontal,
  retarget: Retarget,
  revert: Revert,
  right: Right,
  router: Router,
  script: Script,
  search: Search,
  'security-bots': SecurityBots,
  'security-waf-solid': SecurityWafSolid,
  'security-waf': SecurityWaf,
  'server-origin': ServerOrigin,
  'share-arrow-outline': ShareArrowOutline,
  shield: Shield,
  spectrum: Spectrum,
  speech: Speech,
  'star-outline': StarOutline,
  star: Star,
  stream: Stream,
  subtract: Subtract,
  table: Table,
  'tail-worker': TailWorker,
  target: Target,
  teams: Teams,
  terraform: Terraform,
  'thumbs-down-outline': ThumbsDownOutline,
  'thumbs-down-solid': ThumbsDownSolid,
  'thumbs-up-outline': ThumbsUpOutline,
  'thumbs-up-solid': ThumbsUpSolid,
  time: Time,
  timer: Timer,
  trace: Trace,
  'traffic-attack-browser': TrafficAttackBrowser,
  turnstile: Turnstile,
  twitter: Twitter,
  'two-way': TwoWay,
  'unlock-outline': UnlockOutline,
  upload: Upload,
  'user-multi': UserMulti,
  'user-outline': UserOutline,
  user: User,
  vectorize: Vectorize,
  version: Version,
  'waiting-room': WaitingRoom,
  warning: Warning,
  warp: Warp,
  'web-analytics-logo': WebAnalyticsLogo,
  web3: Web3,
  'workers-bundled': WorkersBundled,
  'workers-constellation': WorkersConstellation,
  'workers-durable-objects': WorkersDurableObjects,
  'workers-for-platforms': WorkersForPlatforms,
  'workers-kv': WorkersKv,
  'workers-pages': WorkersPages,
  'workers-unbound': WorkersUnbound,
  wrangler: Wrangler,
  wrench: Wrench,
  youtube: Youtube,
  zaraz: Zaraz,
  'zero-trust-risk-scoring': ZeroTrustRiskScoring,
  'zerotrust-casb-logo': ZerotrustCasbLogo,
  'zerotrust-networks-logo': ZerotrustNetworksLogo
};

export default IconComponents;